import { useState } from "react";

import { geraet, laeuftAlsApp, useInstallieren } from "../../lib/appInstallation";
import { Karte, Knopf } from "../Basis";

const AUSGEBLENDET = "am-app-hinweis-aus";

function gemerktAusgeblendet(): boolean {
  try {
    return localStorage.getItem(AUSGEBLENDET) === "1";
  } catch {
    return false;
  }
}

/** Kleiner Hinweis auf dem Handy: Portal als App auf den Home-Bildschirm legen. */
export function AppHinweis({ icon = "/icons/icon-192.png" }: { icon?: string }) {
  const installieren = useInstallieren();
  const [aus, setAus] = useState(gemerktAusgeblendet);
  const art = geraet();

  if (aus || laeuftAlsApp()) return null;
  if (art === "andere" && !installieren) return null;

  function ausblenden() {
    try {
      localStorage.setItem(AUSGEBLENDET, "1");
    } catch {
      // ohne Speicher: nur für diesen Besuch ausblenden
    }
    setAus(true);
  }

  return (
    <Karte className="flex items-start gap-4 p-4">
      <img src={icon} alt="" className="h-12 w-12 shrink-0 rounded-xl border border-neutral-100 object-contain" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">Als App aufs Handy</p>
        {installieren ? (
          <>
            <p className="mt-0.5 text-sm text-neutral-600">Mit einem Tipp auf dem Startbildschirm, ohne Browser.</p>
            <Knopf variante="primaer" className="mt-3" onClick={() => void installieren()}>App installieren</Knopf>
          </>
        ) : art === "ios" ? (
          <p className="mt-0.5 text-sm text-neutral-600">
            In Safari unten auf <strong>Teilen</strong> <span aria-hidden>(□↑)</span> tippen, dann{" "}
            <strong>„Zum Home-Bildschirm“</strong>.
          </p>
        ) : (
          <p className="mt-0.5 text-sm text-neutral-600">
            Im Browser oben rechts auf <strong>⋮</strong> tippen, dann <strong>„Zum Startbildschirm hinzufügen“</strong>{" "}
            bzw. <strong>„App installieren“</strong>.
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={ausblenden}
        aria-label="Hinweis ausblenden"
        className="-m-1 rounded-lg p-2 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"
      >
        ✕
      </button>
    </Karte>
  );
}
